import * as  checkpermission from "@/common/js/checkPermission"
import * as localStorages from "@/common/helpers/localStorages";

export const MustBeNotShowButtonGauard = (to, from, next) => {
    let token = localStorage.getItem('token');
    let users = localStorage.getItem('users');
    if (token && users) {
        return next()
    }

};

export const AuthAgentLogin = (to, from, next) => {
    document.title = to.meta?.title ?? 'سیستم کسب درآمد هلو'
    return next()
};
export const Certificate = (to, from, next) => {
    // document.head = to.meta.description ="با استفاده از این صفحه می توانید به سادگی و در سریع ترین زمان اصالت گواهینامه دوره های هلوآکادمی خود را استعلام کنید."
    document.title =  'استعلام گواهینامه دوره های هلوآکادمی - به سادگی و در سریع ترین زمان';
    return next()
};
export const AuthAgent = (to, from, next) => {
    document.title = to.meta?.title ?? 'سیستم کسب درآمد هلو'
    let token = localStorage.getItem('token');
    let users = localStorage.getItem('users');
    if (token && users) {
        return next()
    }
    window.location.replace('/agents/panel/login')

};
export const login = (to, from, next) => {
    let token = localStorage.getItem('token');
    let users = localStorage.getItem('users');
    if (token && users) {
        return next('/panel/dashboard');
    }
    return next()
};

export const paranGuards = (to, from, next) => {
    let token = localStorage.getItem('token');
    let users = localStorage.getItem('users');
    if (token && users) {
        if (checkpermission.permissionView(to.name, 'view') || to.name === 'dashboard') {
            return next()
        }
        return next('/panel/dashboard');

    }
    return next('/panel')
};


